export const BASE_API_URL = `https://api.realviewrealty.com/api`;
export const APPLICATION = `Web`;
export const APPLICATION_TYPE = `EmployeeManagementSystem`;
// dev | design | QA | production
export const ENVIRONMENT = `production`;
export const AppTokenKey = "AppTokenRealView";
export const UserDetails = "UserDetails";
export const LocalAppEncryptKey = "Realviewrealty96241";
